import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const LiveIconColored: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22" height="21" viewBox="0 0 22 16.5">
		<path
			d="M4.117.238a1.521,1.521,0,0,0-1.51-.07L.977.99A1.78,1.78,0,0,0,0,2.592V9.009a1.784,1.784,0,0,0,.977,1.6l1.629.822A1.509,1.509,0,0,0,3.3,11.6a1.538,1.538,0,0,0,.817-.238,1.571,1.571,0,0,0,.736-1.34V1.579A1.575,1.575,0,0,0,4.117.238"
			transform="translate(17.147 2.449)"
			fill="#7d2d29"
		/>
		<path
			d="M10.9,16.5H4.524A4.3,4.3,0,0,1,0,12.033V4.467A4.3,4.3,0,0,1,4.524,0H10.9A4.3,4.3,0,0,1,15.42,4.467v7.566A4.3,4.3,0,0,1,10.9,16.5"
			fill="#ee1313"
		/>
	</svg>
);
